const Page404 = () => {
    return (
        <>
        404 not found
        </>
    )
}
export default Page404;